var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5005 3.96774C21.5961 3.96774 22.4843 3.07953 22.4843 1.98387C22.4843 0.888209 21.5961 0 20.5005 0C19.4048 0 18.5166 0.888209 18.5166 1.98387C18.5166 3.07953 19.4048 3.96774 20.5005 3.96774Z",
    fill: "#383A39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5005 41C21.5961 41 22.4843 40.1118 22.4843 39.0161C22.4843 37.9204 21.5961 37.0322 20.5005 37.0322C19.4048 37.0322 18.5166 37.9204 18.5166 39.0161C18.5166 40.1118 19.4048 41 20.5005 41Z",
    fill: "#ECEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2417 6.41501C12.3373 6.41501 13.2256 5.5268 13.2256 4.43114C13.2256 3.33548 12.3373 2.44727 11.2417 2.44727C10.146 2.44727 9.25781 3.33548 9.25781 4.43114C9.25781 5.5268 10.146 6.41501 11.2417 6.41501Z",
    fill: "#77807F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4773 35.5776C32.0064 36.5034 31.6757 37.6937 30.7499 38.2888C29.8241 38.8179 28.6338 38.4872 28.0386 37.5614C27.5096 36.6356 27.8402 35.4453 28.766 34.8501C29.6918 34.3211 30.9483 34.6517 31.4773 35.5776Z",
    fill: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42227 9.52288C6.34807 10.0519 6.67872 11.2422 6.14969 12.2342C5.62065 13.16 4.43033 13.4906 3.4384 12.9616C2.51259 12.4326 2.18194 11.2422 2.71098 10.2503C3.24001 9.25836 4.49646 8.99384 5.42227 9.52288Z",
    fill: "#9FAAA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5609 28.0386C38.4867 28.5676 38.8174 29.758 38.2884 30.7499C37.7593 31.6757 36.569 32.0064 35.5771 31.4773C34.6513 30.9483 34.3206 29.758 34.8496 28.766C35.3787 27.8402 36.569 27.5096 37.5609 28.0386Z",
    fill: "#F2F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98387 22.4834C3.07953 22.4834 3.96774 21.5952 3.96774 20.4995C3.96774 19.4038 3.07953 18.5156 1.98387 18.5156C0.888209 18.5156 0 19.4038 0 20.4995C0 21.5952 0.888209 22.4834 1.98387 22.4834Z",
    fill: "#B2BBBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0156 22.4834C40.1113 22.4834 40.9995 21.5952 40.9995 20.4995C40.9995 19.4038 40.1113 18.5156 39.0156 18.5156C37.9199 18.5156 37.0317 19.4038 37.0317 20.4995C37.0317 21.5952 37.9199 22.4834 39.0156 22.4834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.43847 28.0386C4.36428 27.5096 5.5546 27.8402 6.14976 28.766C6.6788 29.6918 6.34815 30.8822 5.42234 31.4773C4.49654 32.0064 3.30621 31.6757 2.71105 30.7499C2.11589 29.8241 2.51267 28.6338 3.43847 28.0386Z",
    fill: "#C5CCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5771 9.52299C36.5029 8.99396 37.6932 9.3246 38.2884 10.2504C38.8174 11.1762 38.4867 12.3665 37.5609 12.9617C36.6351 13.4907 35.4448 13.1601 34.8496 12.2343C34.3206 11.3085 34.6513 10.052 35.5771 9.52299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5225 35.5776C10.0515 34.6517 11.2419 34.3211 12.2338 34.8501C13.1596 35.3792 13.4902 36.5695 12.9612 37.5614C12.4322 38.4872 11.2419 38.8179 10.2499 38.2888C9.32411 37.6937 8.99347 36.5034 9.5225 35.5776Z",
    fill: "#D9DDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0386 3.43888C28.5676 2.51308 29.758 2.18243 30.7499 2.71146C31.6757 3.2405 32.0064 4.43082 31.4773 5.42276C30.9483 6.34856 29.758 6.67921 28.766 6.15017C27.8402 5.62114 27.5096 4.43082 28.0386 3.43888Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.5b47e68e.svg";
export { ForwardRef as ReactComponent };